export default "__VITE_ASSET__6JPsNEwU__"